import React, { useContext } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { GlobalContext } from '../App'

// Picks exactly one base location for a record that must belong to one
// (medicine stores and bags, for example). Unlike BaseLocationPicker there is
// no "All Locations" option - that picker is for filters and access scopes.
// `value` may be a base location object or just its id.
const SingleBaseLocationSelect = ({
  value,
  onChange,
  label = 'Base location',
  required = true,
  disabled = false,
  size = 'medium',
  helperText,
  sx,
  ...props
}) => {
  const { baseLocationOptions: options = [] } = useContext(GlobalContext)
  const valueId = value?._id ?? value ?? null
  const selected =
    options.find((option) => String(option._id) === String(valueId)) ??
    (value && typeof value === 'object' && value.name ? value : null)

  return (
    <Autocomplete
      value={selected}
      onChange={(e, option) => onChange(option)}
      options={options}
      isOptionEqualToValue={(a, b) => String(a?._id) === String(b?._id)}
      getOptionLabel={(option) => option?.name || ''}
      disableClearable={required}
      disabled={disabled}
      size={size}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          helperText={helperText}
        />
      )}
      {...props}
    />
  )
}

export default SingleBaseLocationSelect
